import styled from "styled-components"

const SpanStyling=styled.span`
    color:black;
    margin-right:${props=>props.margin}px;
    font-weight:bold;
`

export default SpanStyling